import React from 'react';

const StatsCards = ({ users, companies }) => {
  const stats = [
    { 
      label: 'Total Users', 
      value: users.length, 
      icon: '👥', 
      color: 'bg-blue-100 text-blue-600' 
    },
    { 
      label: 'Active Users', 
      value: users.filter(u => u.is_active).length, 
      icon: '✅', 
      color: 'bg-green-100 text-green-600' 
    },
    { 
      label: 'Admins', 
      value: users.filter(u => u.role === 'admin' || u.role === 'superadmin').length, 
      icon: '👑', 
      color: 'bg-purple-100 text-purple-600' 
    },
    { 
      label: 'Managed Users', 
      value: users.filter(u => u.role === 'user').length, 
      icon: '👤', 
      color: 'bg-gray-100 text-gray-600' 
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-lg hover:shadow-xl transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{stat.value}</p>
            </div>
            <div className={`p-3 rounded-full ${stat.color}`}>
              <span className="text-xl">{stat.icon}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;